Vue.filter('commaToDot', function (price) {
  return price.replace(/,/g, '.');
});
